module.exports = __webpack_public_path__ + "img/map-2-f.b616b478.png";